import { Box, Text } from '@factorialco/deprecated-design-system'
import { F0Dialog } from '@factorialco/f0-react'

import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

import { useDestroyTraining } from 'modules/trainings/hooks/Trainings/useDestroyTraining'

interface BulkDeleteProps {
  itemIds: string[]
  onClose: () => void
}

const BulkDelete = ({ itemIds, onClose }: BulkDeleteProps) => {
  const { destroyTraining, loading } = useDestroyTraining()

  const onSubmit = async () => {
    const response = await destroyTraining({ ids: itemIds })
    const handled = handleResult(response, () => {
      app.setFlash({
        type: 'wrong',
        message: i18n.t('trainings.delete_training.error_delete_bulk'),
      })
    })

    if (handled.success) {
      app.setFlash({
        type: 'correct',
        message: i18n.t('trainings.delete_training.success_delete_bulk'),
      })
      onClose()
    }
  }

  return (
    <F0Dialog
      isOpen
      onClose={onClose}
      title={i18n.t('trainings.delete_training.title_bulk')}
      primaryAction={{
        label: i18n.t('trainings.delete_training.accept'),
        onClick: onSubmit,
        loading: loading,
      }}
      secondaryAction={{
        label: i18n.t('trainings.delete_training.cancel'),
        onClick: onClose,
      }}
    >
      <Box gap="s8" flexDirection="column">
        <Text.Normal size="300">{i18n.t('trainings.delete_training.description_bulk')}</Text.Normal>
      </Box>
    </F0Dialog>
  )
}

export default BulkDelete
